var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3806 15.6666H2.30641C2.05141 15.6666 1.84391 15.48 1.84391 15.25V2.74996C1.84391 2.51996 2.05141 2.33329 2.30641 2.33329H6.01058V5.79163C6.01058 7.10163 7.02475 8.16663 8.27225 8.16663H11.8439V15.25C11.8439 15.48 11.6356 15.6666 11.3806 15.6666ZM11.5514 6.49996H8.27225C7.94391 6.49996 7.67725 6.18246 7.67725 5.79163V2.33329H7.77058L11.5514 6.49996ZM13.2939 5.93996L8.75725 0.939959C8.59974 0.765793 8.37558 0.666626 8.13975 0.666626H2.30641C1.13225 0.666626 0.177246 1.60163 0.177246 2.74996V15.25C0.177246 16.3983 1.13225 17.3333 2.30641 17.3333H11.3806C12.5547 17.3333 13.5106 16.3983 13.5106 15.25V6.49996C13.5106 6.29246 13.4331 6.09329 13.2939 5.93996Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/IconFile.e9167b01f50e43ce264a715f0383add6.svg";
export { ForwardRef as ReactComponent };